'use client';

import React, { useCallback } from "react";
import { signIn, signOut, useSession } from "next-auth/react"
import { Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, User } from "@heroui/react";

export const UserMenu = ({ initialSession }: { initialSession?: any }) => {
  const { data: session, status } = useSession();
  const effectiveSession = session ?? initialSession;

  const authenticated = Boolean(effectiveSession?.user);
  const { email, name, image } = effectiveSession?.user || {};

  const menuItems = useCallback(() => {
    const items = [];

    if (!authenticated) {
      items.push({
        onClick: () => signIn('google'),
        label: "Увійти",
      });
    } else {
      items.push({
        href: "/sources",
        label: "Адміністрування",
      });
      items.push({
        onClick: () => signOut(),
        label: "Вийти",
      });
    }

    return items;
  }, [authenticated]);

  return (
    <Dropdown placement="bottom-end">
      <DropdownTrigger>
        <User
          as="button"
          avatarProps={{
            isBordered: true,
            src: authenticated ? (image || '') : undefined,
          }}
          className="transition-transform pl-4"
          description={authenticated ? email : ""}
          name={authenticated ? name : ""}
        />
      </DropdownTrigger>
      <DropdownMenu aria-label="User Actions" variant="flat">
        {menuItems().map((item: any, index: number) => (
          <DropdownItem key={index} {...item} >
            {item.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}
